import { type UseQueryOptions, useQuery } from '@tanstack/vue-query'
import { HR_ARTICLES_UNREAD_COUNT } from '../articleEndpoints'
import { ARTICLES_UNREAD_COUNT_QUERY_KEY } from '../articleQueryKeys'
import { axiosInstance } from '@/modules/Core/plugins/axios'
import type { UnreadArticlesCountDto } from '@/modules/Article/types/api/article'

export function fetchUnreadArticlesCount(): Promise<UnreadArticlesCountDto> {
  return axiosInstance
    .get<UnreadArticlesCountDto>(HR_ARTICLES_UNREAD_COUNT)
    .then((response) => response.data)
}

export function useUnreadArticlesCountQuery(
  options?: Omit<
    UseQueryOptions<Awaited<ReturnType<typeof fetchUnreadArticlesCount>>>,
    'queryKey' | 'queryFn'
  >
) {
  return useQuery({
    queryKey: [ARTICLES_UNREAD_COUNT_QUERY_KEY],
    queryFn: fetchUnreadArticlesCount,
    ...options,
  })
}
